/**
 * Initializes the tab functionality for collections.
 * Adds click event listeners to tabs to switch between different content sections.
 */
export const tabsCollections = () => {
  
  const tabs = document.querySelectorAll('.tabs-collections__tab');
  const tabsContent = document.querySelectorAll('.tabs-collections__collection');

  if (tabs.length) {
    setTimeout(() => {
      tabsContent.forEach((content, index) => {
        if (index != 0) {
          content.classList.add('visually-hidden');
        }
      });

      if (document.querySelector('.tabs-collections__tabs')) {
        let allTabs = document.querySelectorAll('.tabs-collections__tabs'),
        allSliders = document.querySelectorAll('.tabs-collections__content'),
        spinnerContainer = document.querySelectorAll('.div-spiner-content');

        allTabs.forEach((tab) => {
          tab.style.display = 'flex';
        });

        allSliders.forEach((sliders) => {
          sliders.style.display = 'block';
        });

        spinnerContainer.forEach((spiner) => {
          spiner.remove();
        });
      }

    }, 500);

    tabs.forEach((tab) => {

      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-linkid');
        const targetContent = document.querySelector(`.tabs-collections__collection#${target}`);

        tabs.forEach(tab => tab.classList.remove('active'));
        tabsContent.forEach(content => content.classList.add('visually-hidden'));
        tab.classList.add('active');
        targetContent.classList.remove('visually-hidden');
      });
    });
  }
}

/**
 * Opens the backdrop and moves elements from the source container to the target container.
 *
 * @param {HTMLElement} backdrop - The backdrop element.
 * @param {HTMLElement} sourceContainer - The container from which elements are moved.
 * @param {HTMLElement} targetContainer - The container to which elements are moved.
 */
const openElements = (backdrop, sourceContainer, targetContainer) => {
  if (!targetContainer.classList.contains('active')) {
    targetContainer.classList.add('active');
    while (sourceContainer.firstChild) {
      targetContainer.appendChild(sourceContainer.firstChild);
    }
  }

  backdrop.style.display = 'block';
  document.body.classList.add('body-no-scroll');
}

/**
 * Closes the backdrop and moves elements from the target container back to the source container.
 *
 * @param {HTMLElement} backdrop - The backdrop element.
 * @param {HTMLElement} targetContainer - The container from which elements are moved back.
 */
export const closeElements = (backdrop, targetContainer) => {
  if (backdrop) {
    backdrop.addEventListener('click', () => {
      const finalContainer = document.getElementById(window.sizeContainer.getAttribute("id"));
      while (targetContainer.firstChild) {
        finalContainer.appendChild(targetContainer.firstChild);
      }
      backdrop.style.display = 'none';
      document.body.classList.remove('body-no-scroll');
      targetContainer.classList.remove('active');
      window.sizeContainer = null;
    });
  }
}

/**
 * Sets up click event handlers for mobile carousel buttons to open and close the backdrop.
 *
 * @param {NodeList} buttons - A list of buttons that trigger the carousel.
 * @param {HTMLElement} backdrop - The backdrop element.
 */
const setupMobileClickHandlerCarousel = (buttons, backdrop) => {
  if (buttons && backdrop) {
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const bag = e.target;
        const targetContainer = document.getElementById("tabs-sizes-container");
        const sizeContainer = bag.closest('.block-inner-inner').querySelector('.product-block__sizes-container');
        window.sizeContainer = sizeContainer;

        if (sizeContainer && targetContainer) {
          openElements(backdrop, sizeContainer, targetContainer);
          closeElements(backdrop, targetContainer);
        }
      });
    });
  }
}

/**
 * Initializes the carousel size handler for the given sections.
 * Sets up click handlers for carousel buttons to manage the backdrop and size container.
 *
 * @param {NodeList} sections - A list of sections containing carousels.
 */
export const carouselSizeHandler = (sections) => {
  sections.forEach(container => {
    const carouselCollection = container.querySelectorAll('.tabs-collections_slider');

    carouselCollection.forEach(carousel => {
      const buttons = carousel.querySelectorAll('.image-cont .sizes-container .add_to_cart_plp:not(.sizes):not(.button--sold-out)');
      const backdrop = container.querySelector('.product-block__backdrop');

      setupMobileClickHandlerCarousel(buttons, backdrop);
    });
  });
}
